/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=82fbd31c"
import script from "./Layout.vue?vue&type=script&setup=true&lang=ts"
export * from "./Layout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Layout.vue?vue&type=style&index=0&id=82fbd31c&prod&lang=scss&module=true"
import style1 from "./Layout.vue?vue&type=style&index=1&id=82fbd31c&prod&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports